import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { axiosInstance } from '@appblocks/frontend/client/utils';
import Loading from '@appblocks/frontend/client/Components/Loading';
import Header from '@appblocks/frontend/client/Header';

export default class PaginationComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            min: 0,
            max: 9,
        };
    }

    setWindow(min, max) {
        this.setState({
            min,
            max,
        });
    }

    render() {
        if (this.props.total === 0) {
            return null;
        }
        const pages = Math.ceil(this.props.total / this.props.perPage);
        const items = Array.from(Array(pages).keys());
        return (
            <>
                <div className="row mb-3">
                    <div className="col-md-12 d-flex pagination-container">
                        <Pagination>
                            {this.state.min > 0 && (
                                <Pagination.Item
                                    onClick={() => {
                                        this.setWindow(this.state.min - 10, this.state.min);
                                    }}
                                >
                                    ...
                                </Pagination.Item>
                            )}
                            {items.map((item) => {
                                if (item > this.state.max
                                    || item < this.state.min) {
                                    return null;
                                }
                                return (
                                    <Pagination.Item
                                        key={item}
                                        active={item === this.props.page}
                                        onClick={() => this.props.setPage(item)}
                                    >
                                        {item + 1}
                                    </Pagination.Item>
                                );
                            })}
                            {(items.length > 10 && this.state.max < items.length - 1) && (
                                <Pagination.Item
                                    onClick={() => {
                                        this.setWindow(this.state.max, this.state.max + 10);
                                    }}
                                >
                                    ...
                                </Pagination.Item>
                            )}
                        </Pagination>
                        <div className="ms-3 d-flex align-items-center">
                            <small>
                                {`Showing ${this.props.perPage * this.props.page + 1} - ${Math.min(this.props.perPage
                                    * (this.props.page + 1), this.props.total)} of ${this.props.total}`}
                            </small>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
